<forge-scaffold>
    <div slot="body" style="height: 100%; min-height: 70vh;">
        <busy-indicator *ngIf="loading" page="true"></busy-indicator>

        <iframe *ngIf="showViewer" fxFlex="auto" style="border: none;" id="embeddedPage" [attr.data-hash]="hashId"></iframe>

        <div *ngIf="tcm && !hasTcmPermission">
            <div class="forge-typography--heading2">You do not have permission for TCM. Please contact an
                administrator.</div>
        </div>
    </div>

    <div slot="body-footer" *ngIf="!loading && !tcm && !hideFooter" fxLayout="row" fxLayoutAlign="end center" class="metadata-form--footer form-actions-container">
        <forge-button [dense]="compactMode" variant="outlined" (click)="close()" telemetry="Submission-Close Document" tabindex="0">
            Close
        </forge-button>
        <forge-split-button *ngIf="allowEmail" [dense]="compactMode" variant="raised" theme="primary">
            <forge-button [dense]="compactMode" variant="raised" telemetry="Submission-{{currentCompoundOption}}" (click)="compoundAction()">
                {{currentCompoundOption}}
            </forge-button>
            <forge-menu [options]="compoundOptions" placement="top-right" highlight-first="false" 
                        [dense]="compactMode" (forge-menu-select)="compoundAction($event)" (forge-menu-open)="menuOpened($event)">
                <forge-button [dense]="compactMode" variant="raised" aria-label="Save-keyboard_arrow_down">
                    <forge-icon name="keyboard_arrow_down"></forge-icon>
                    </forge-button>
            </forge-menu>
        </forge-split-button>

        <forge-button *ngIf="!allowEmail" [dense]="compactMode" variant="raised" (click)="download()" telemetry="Submission-Download" tabindex="0" class="metadata-form--footer-button">
            Download
        </forge-button>
    </div>
</forge-scaffold>
